(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TicketDetailController', TicketDetailController);

    TicketDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ticket', 'Ticket_status', 'Campagna'];

    function TicketDetailController($scope, $rootScope, $stateParams, previousState, entity, Ticket, Ticket_status, Campagna) {
        var vm = this;

        vm.ticket = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:ticketUpdate', function(event, result) {
            vm.ticket = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
